import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import SecurityOps from './pages/services/SecurityOps';
import PenTest from './pages/services/PenTest';
import EmergencyResponse from './pages/services/EmergencyResponse';
import VulnScan from './pages/services/VulnScan';
import CodeAudit from './pages/services/CodeAudit';
import AssetMapping from './pages/services/AssetMapping';
import './index.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-wrapper">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/security-ops" element={<SecurityOps />} />
            <Route path="/services/pen-test" element={<PenTest />} />
            <Route path="/services/emergency-response" element={<EmergencyResponse />} />
            <Route path="/services/vuln-scan" element={<VulnScan />} />
            <Route path="/services/code-audit" element={<CodeAudit />} />
            <Route path="/services/asset-mapping" element={<AssetMapping />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
